<div class="flex flex-col pt-2 md:pt-24 text-center">
  <span class="text-sm md:text-base">Dé centrale boekingssite voor opleidingen en skills</span>
  <img
    [src]="skillCentralLogo"
    alt="SkillCentral logo met boek en opleidingskalender"
    width="6334"
    height="2878"
    class="mx-auto mt-4 w-64 max-w-full h-auto object-contain md:w-80"
  />
</div>
